import React from 'react'

export default function TableSortDescend(props) {
  return (
    <svg
      width={props.width ? props.width : '10'}
      height={props.height ? props.height : '8'}
      viewBox='0 0 10 8'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g opacity='1'>
        <path
          d='M9.16534 0C9.83954 0 10.2217 0.901004 9.86183 1.5494L9.80532 1.64018L5.63998 7.64018C5.32913 8.08795 4.77367 8.11781 4.43021 7.72974L4.36002 7.64018L0.19468 1.64018C-0.236934 1.01846 0.0950087 0.0891988 0.740381 0.00600471L0.83466 0H9.16534Z'
          fill={props.color ? props.color : '#FFFFFF'}
        />
      </g>
    </svg>
  )
}
